export default {
	cihangban: 'この便',
	paifangliang: '排出量は、選択した座席クラスの1人の乗客に対して計算されます',
	chengke: '乗客',
	quebaoziliaozhengque: 'すべての情報が正確であることを確認してください',
	ruhetianxiechengke: '乗客情報の記入方法',
	beizhu: '備考',
	piaohao: 'チケット番号',
	chakanpiaojiaguize: 'チケット価格のルールを確認する',
	shengyushijian: '予約の完了まで残り X 分',
	zongjie: '費用',
	shuifeifujia: '税および追加料金',
	zonge: '合計',
	xingbie: '性別',
	nan: '男性',
	nv: '女性',
	xingshi: '姓',
	zhongjianming: 'ミドルネーム',
	mingzi: '名前',
	lizi0: '例: 李',
	ruyou: 'ある場合',
	lizi: '例: SIU MENG',
	zhengjianleixing: '証件タイプ',
	qingxuanze: '選択してください',
	huzhaohaoma: 'パスポート番号',
	huzhao: 'パスポート',
	qingshuru: '入力してください',
	huzhaoguojia: 'パスポートの国・地域',
	daoqiriqi: 'パスポートの有効期限',
	chushengriqi: '生年月日',
	shifouchangke: 'フリークエントフライヤー会員ですか？',
	lianluoren: '連絡先情報',
	dianyoudizhi: 'メールアドレス',
	zhengquedianyoudizhi: '正確なメールアドレス',
	lianluodianhua: '連絡先電話',
	qingshurudianhua: '電話番号を入力してください',
	guojia: '国',
	wanchengyuding: '予約の完了',
	wancheng: '完了',
	fukuanxijie: '支払いの詳細',
	shuikuanfujiafei: '税および追加料金込み',
	woyiyueduotiaokuan: '私は契約条件をよく理解し、同意します',
	woyiyueduo: '私は契約条件をよく理解し、同意します',
	baocunxiangxixinxi: 'ここに詳細情報を保存して、将来のフライト予約を自動的に入力できるようにします。',
	xiayibu: '次へ',
	fanhui: '戻る',
	baocun: '保存',
	xuanzezuowei: '座席を選択してください',
	ewaituibu: 'エクストラレッグルームシート',
	shouxuan: '優先',
	biaozhun: '標準',
	queren: '確認',
	chongzhi: 'リセット',
	quxiao: 'キャンセル',
	yixuan: '選択済み',
	shangwu: 'ビジネス',
	jingji: 'エコノミー',
	meiyouxuanwei: '座席が選択されていません',
	xuanzezhong: '選択中',
	xiagehangban: '次の便',
	chuangjiandingdan: '注文を作成',
	chengkeanzhengjian:
		'すべての敬称と乗客の名前は、パスポートまたは他の有効な旅行証明書に表示されているものと完全に一致するように入力する必要があります。取引が成功した後、所有権や乗客の名前の変更は許可されません。',
	shurudianziyoujian: '確認メールを受信するメールアドレスを入力してください。',
	hangbanbiangengshouyueshu:
		'航空会社の選択された規定と条件の制約を受ける航空券の変更。',
	yudingzhongguanli:
		'予約は引き続き*「予約済み」で変更できます。ただし、確認済みの予約に対する変更には変更料金がかかります。新規購入の費用を超える変更。',
	cuxiaopiaojiabu: 'プロモーション料金で購入されたチケットは変更できない場合があります。',
	chakanlvxingjianyi:
		'旅行アドバイスと輸送規則をご覧ください。許可されている変更についての詳細をご確認してください。',
};
